export default {
  SETOPTIONS(state, res) {
    Object.keys(res).forEach(item => (state[item] = res[item]))
  },
  SETADMINID(state, adminId) {
    state.pasResForm.adminId = adminId;
  },

  SETIMGCODEPATH(state, imgCodePath) {
    state.imgCodePath = imgCodePath;
    state.ruleForm.baseReqDto = '';
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/UserLogin/mutations.js